import React, { useEffect, useRef, useState, createContext, useContext } from "react";
import { createPortal } from "react-dom";

const ToolContext = createContext();

const ToolItem = ({ item }) => { 
  const handleClick = useContext(ToolContext);

  return (
    <a href="#" className="ftc-image-tools__item" onClick={() => handleClick(item)}>
      <i className={`fi fi-${item.toLowerCase()}`} />
      {i18n.t(`image-tools.${item.toLowerCase()}`)}
    </a>
  );
};

const ToolsList = ({ tools, position, listRef }) => (
  <div
    className="ftc-image-tools__list"
    ref={listRef}
    style={{
      position: 'absolute',
      ...position
      // top: position.top,
      // left: position.left,
    }}
  >
    {tools.map((tool) => (
      <ToolItem key={tool} item={tool} />
    ))}
  </div>
);

const Tools = ({ url, onChange }) => {
  const tools = ['Annotate', 'Adjust', 'Finetune', 'Filters']; // Other: Watermark, Resize 
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const containerRef = useRef(null);
  const listRef = useRef(null);

  const handleToolClick = (tool) => {
    warehouseLoader.show(onChange, 'edit', { tool, url });
  }

  useEffect(() => {
    if (containerRef.current && listRef.current) {
      const parentRect = containerRef.current.getBoundingClientRect();
      const listRect = listRef.current.getBoundingClientRect();
      const left = parentRect.left + (parentRect.width - listRect.width) / 2;
      const top = parentRect.top - listRect.height;
      setPosition({ top, left });
    }
  }, []);

  return (
    <div className="ftc-image-tools" ref={containerRef}>
      <ToolContext.Provider value={handleToolClick}>
        {createPortal(
          <ToolsList tools={tools} position={position} listRef={listRef}/>,
          document.body
        )}
      </ToolContext.Provider>
    </div>
  );
};

export default Tools;
